module.exports = __webpack_public_path__ + "img/dice-two.b8873fc8.svg";